// This file provides a mock implementation of @hookform/resolvers/yup
// to resolve TypeScript errors without requiring the actual library

import * as yup from 'yup';

interface ResolverOptions {
  mode?: 'sync' | 'async';
  context?: any;
  // Add other options as needed
}

export const yupResolver = (schema: yup.AnyObjectSchema, options?: ResolverOptions) => {
  return (values: any) => {
    try {
      const data = schema.validateSync(values, {
        abortEarly: false,
        context: options?.context,
      });
      
      return {
        values: data,
        errors: {},
      };
    } catch (e) {
      const yupError = e as yup.ValidationError;
      const errors = yupError.inner.reduce((acc, error) => {
        if (error.path) {
          acc[error.path] = {
            type: error.type ?? 'validation',
            message: error.message,
          };
        }
        return acc;
      }, {} as Record<string, { type: string; message: string }>);
      
      return {
        values: {},
        errors,
      };
    }
  };
};